import { IGroup } from '@fluentui/react';
import { map } from 'lodash';

/**
 * Takes a list of groups and applies the collapsed state to each group.
 */
export const applyGroupCollapseBehavior = (
  groupList: IGroup[],
  isAllGroupsCollapsed: boolean,
  collapsedGroups: any[]
) =>
  map(groupList, group => {
    return {
      ...group,
      isCollapsed:
        !isAllGroupsCollapsed === collapsedGroups?.indexOf(group.key) > -1,
    };
  });
